export const API_BASE_URL = "https://api.ansera.ai/api"

export const FAST_API_BASE_URL = "https://api.ansera.ai"
// export const FAST_API_BASE_URL = "http://127.0.0.1:8000"

// export const FAST_API_BASE_URL = " https://ventless-realterable-leonarda.ngrok-free.dev"
export  const LAMBDA_BASE_URL = "https://s4lek198uh.execute-api.us-east-1.amazonaws.com/dev"

